import Vue from 'vue';
import App from './app.vue';
import router from './router/router';
import Router from 'vue-router';
import store from './store/store';
import design from './styles/main.scss';
import VueMq from 'vue-mq';
import './utils/service-worker';
import { VueHammer } from 'vue2-hammer';
import * as VueGoogleMaps from 'vue2-google-maps';
import {Viewport, RouteName, AppConfig} from './utils/enums';
import {
  scrollDirective,
  focusDirective,
  outsideClickDirective
} from './utils/directives';
import { capitalize, toSimpleDateFormat } from './utils/filters';
// import VueAppInsights from 'vue-application-insights'
 
// Vue.prototype.$viewport = Viewport;
Vue.prototype.$routeName = RouteName;

// Don't warn about using the dev version
Vue.config.productionTip = false;

Vue.use(Router);
Vue.use(VueHammer);
// Vue.use(Notification);
Vue.use(VueMq, {
  breakpoints: {
    [Viewport.MOBILE]: Number(design['mobile'].replace('px', '')),
    [Viewport.TABLET]: Number(design['tablet'].replace('px', '')),
    [Viewport.DESKTOP]: Number(design['desktop'].replace('px', ''))
  }
});

Vue.filter('capitalize', capitalize);
Vue.filter('toSimpleDateFormat', toSimpleDateFormat);

Vue.directive('scroll', scrollDirective);
Vue.directive('focus', focusDirective);
Vue.directive('click-outside', outsideClickDirective);

Vue.use(VueGoogleMaps, {
  load: {
    key: AppConfig.GOOGLE_MAPS_API_KEY,
    libraries: ['places', 'drawing', 'visualization', 'geometry']
  },
  installComponents: true
});
//
// Vue.use(VueAppInsights, {
//   id: '5a9af7db-f70d-4a36-8ce3-3324ffdfb560',
//   router
// })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
